export default __webpack_public_path__ + "static/media/token_xph.8f3482d8.svg";